"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const Mixin_1 = require("../Util/Mixin");
const IContainerInjection_1 = require("../Container/IContainerInjection");
const WidgetError_1 = require("../Error/WidgetError");
/**
 * Factory for any class that can be created with container.
 */
class ContainerAwareFactory {
    /**
     * Constructs the factory.
     *
     * @param {Container} container
     */
    constructor(container) {
        this.container = container;
    }
    /**
     * Creates instance of class with possible container injection.
     *
     * @param {*} classReference
     * @param {*[]} padArguments
     * @return {*}
     */
    create(classReference, ...padArguments) {
        if (!Mixin_1.extendsMixin(classReference, IContainerInjection_1.default)) {
            return new classReference(...padArguments);
        }
        const instance = classReference.create(...padArguments, this.container);
        if (!instance) {
            throw new WidgetError_1.default(`Failed to create instance with container injection for '${classReference.name}'.`);
        }
        return instance;
    }
}
exports.default = ContainerAwareFactory;
